export default "__VITE_ASSET__BsevqoMG__"